class MainRoutingController {
  constructor() {
  }
}

export default MainRoutingController;



// WEBPACK FOOTER //
// ./client/app/features/mainRouting/mainRouting.controller.js